// Event delegation on document (not addEventListener on the buttons/track
// themselves) — the cart-drawer's content gets replaced wholesale via
// innerHTML on every cart update (add/remove item), which would silently
// detach any listeners bound directly to the original elements. Delegation
// keeps working regardless of how many times the markup is rebuilt.

function cartDrawerCarouselUpdateArrows(track) {
  var container = track.closest('.cart-drawer__collection');
  if (!container) return;
  var prevBtn = container.querySelector('[data-cart-drawer-carousel-prev]');
  var nextBtn = container.querySelector('[data-cart-drawer-carousel-next]');
  if (!prevBtn || !nextBtn) return;
  var maxScroll = track.scrollWidth - track.clientWidth;
  // Both arrows stay visible at all times now (never `hidden`) — only a
  // visual "disabled" state toggles, matching the reference design (left
  // arrow greyed out but present at the start, not absent).
  prevBtn.hidden = false;
  nextBtn.hidden = false;
  var atStart = track.scrollLeft <= 1;
  var atEnd = maxScroll <= 1 || track.scrollLeft >= maxScroll - 1;
  prevBtn.classList.toggle('cart-drawer__collection-arrow--disabled', atStart);
  prevBtn.disabled = atStart;
  nextBtn.classList.toggle('cart-drawer__collection-arrow--disabled', atEnd);
  nextBtn.disabled = atEnd;
}

// Proactive initialization: the 'scroll' listener below only reacts once
// the user actually scrolls, so on first paint the prev arrow was left
// exactly as the markup's static `hidden` attribute rendered it (see
// snippets/cart-drawer.liquid) — i.e. missing entirely instead of visible
// but disabled. Running the same update immediately covers the initial
// render without needing to touch that markup.
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.cart-drawer__collection-track').forEach(cartDrawerCarouselUpdateArrows);
});

document.addEventListener('click', function (event) {
  var prevBtn = event.target.closest('[data-cart-drawer-carousel-prev]');
  var nextBtn = event.target.closest('[data-cart-drawer-carousel-next]');
  var btn = prevBtn || nextBtn;
  if (!btn) return;

  var container = btn.closest('.cart-drawer__collection');
  var track = container ? container.querySelector('.cart-drawer__collection-track') : null;
  if (!track) return;

  var item = track.querySelector('.cart-drawer__collection-item');
  var itemWidth = item ? item.getBoundingClientRect().width : track.clientWidth * 0.8;
  var direction = prevBtn ? -1 : 1;
  track.scrollBy({ left: direction * (itemWidth + 16), behavior: 'smooth' });
});

// 'scroll' does not bubble, so delegation requires the capture phase —
// this still reaches a freshly-rebuilt track the same as the original one.
document.addEventListener(
  'scroll',
  function (event) {
    var track = event.target;
    if (!track.classList || !track.classList.contains('cart-drawer__collection-track')) return;
    cartDrawerCarouselUpdateArrows(track);
  },
  true
);

// Desktop mouse click-and-drag panning. overflow-x:auto containers already
// support touch panning and horizontal wheel/trackpad scroll natively —
// only mouse click-drag needs explicit handling, since browsers don't do
// that for a plain scroll container.
(function () {
  var isDown = false;
  var moved = false;
  var startX = 0;
  var startScrollLeft = 0;
  var activeTrack = null;
  var DRAG_THRESHOLD = 5;

  document.addEventListener('mousedown', function (event) {
    var track = event.target.closest('.cart-drawer__collection-track');
    if (!track) return;
    isDown = true;
    moved = false;
    activeTrack = track;
    startX = event.pageX;
    startScrollLeft = track.scrollLeft;
  });

  document.addEventListener('mousemove', function (event) {
    if (!isDown || !activeTrack) return;
    var delta = event.pageX - startX;
    if (Math.abs(delta) > DRAG_THRESHOLD) moved = true;
    if (!moved) return;
    event.preventDefault();
    activeTrack.classList.add('cart-drawer__collection-track--dragging');
    activeTrack.scrollLeft = startScrollLeft - delta;
  });

  function stopDrag() {
    if (activeTrack) activeTrack.classList.remove('cart-drawer__collection-track--dragging');
    isDown = false;
    activeTrack = null;
  }

  document.addEventListener('mouseup', stopDrag);
  document.addEventListener('mouseleave', stopDrag);

  // Suppress the click that follows a real drag (capture phase, ahead of
  // the arrow-click handler above and any link navigation) so "Shop Now"
  // links inside the track don't fire when the user was panning, not
  // clicking.
  document.addEventListener(
    'click',
    function (event) {
      if (!moved) return;
      var track = event.target.closest('.cart-drawer__collection-track');
      if (!track) return;
      event.preventDefault();
      event.stopPropagation();
      moved = false;
    },
    true
  );
})();
